import { createHash } from 'crypto-browserify';

function generateNoise(length, password) {
    const noise = new Uint8Array(length);
    let seed = 0;

    for (let i = 0; i < password.length; i++) {
        seed += password.charCodeAt(i);
    }

    for (let i = 0; i < length; i++) {
        seed = (seed * 9301 + 49297) % 233280;
        noise[i] = seed % 256;
    }

    return noise;
}

export function encryptImage(imageData, password) {
    
    // Why Use XOR for Encryption?
    // XOR is a bitwise operation that has the property:

    // A⊕B⊕B=A

    // This means that if you XOR a number with another number twice, you get back the original number. This property is used for encryption and decryption:

    // Encrypt: 
    // encrypted = original⊕noise

    // Decrypt:
    // original = encrypted⊕noise
    
    password = createHash('sha256').update(password).digest('base64')
    const noise = generateNoise(imageData.length / 4 * 3, password); // Generate noise for RGB channels
    const encryptedData = new Uint8ClampedArray(imageData.length);
    for (let i = 0; i < imageData.length; i += 4) {
        encryptedData[i] = imageData[i] ^ noise[i / 4];         // XOR with noise for red Channel
        encryptedData[i + 1] = imageData[i + 1] ^ noise[i / 4]; // XOR with noise for green Channel
        encryptedData[i + 2] = imageData[i + 2] ^ noise[i / 4]; // XOR with noise for blue Channel
        encryptedData[i + 3] = imageData[i + 3];                // Keep alpha Channel
    }
    return encryptedData;
}

export function imageDataToDataURL(imageData) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = imageData.width;
    canvas.height = imageData.height;
    ctx.putImageData(imageData, 0, 0);
    return canvas.toDataURL();
}